import {useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link, useParams} from 'react-router-dom'
import {useFormik} from 'formik'
import {emailLogin} from '../core/_requests'
import {useIntl} from 'react-intl'
// import {ElectricalServicesSharp} from '@mui/icons-material'

const initialValues = {
  username: '',
  dateofbirth: ''
}

const emailLoginSchema = Yup.object().shape({
  username: Yup.string().min(2, 'Minimum 2 characters').max(250, 'Maximum 250 charcters').required('Username is required'),
  dateofbirth: Yup.string().min(10, 'Please enter your date of birth - MM/DD/YYYY').max(10, 'Please enter your date of birth - MM/DD/YYYY').required('Date of Birth (MM/DD/YYYY) is required')
})

export function EmailLogin() {
  // console.log('In Function')
  const intl = useIntl()
  const [errorInformation, setErrorInformation] = useState<string | false>()

  // console.log(pagetype)

  const [loading, setLoading] = useState(false)
  const [accessLocked, setAccessLocked] = useState(false)
  const [invalidLogin, setInvalidLogin] = useState(false)
  const [hasErrors, setHasErrors] = useState<boolean | undefined>(undefined)
  const formik = useFormik({
    initialValues,
    validationSchema: emailLoginSchema,
    onSubmit: (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      setHasErrors(undefined)
      setTimeout(() => {
        emailLogin(values.username, values.dateofbirth)
          .then(({data: {result}}) => {
            setHasErrors(false)
            setLoading(false)
          })
          .catch((err: any) => {
            setSubmitting(false)
            setLoading(false)
            setHasErrors(true)
            // setStatus('The login detail is incorrect')
            if (err) {
              if (err.response) {
                if (err.response.data.status && err.response.data.status === 'Access Locked') {
                  setAccessLocked(true)
                  setInvalidLogin(false)
                } else {
                  if (err.response.data.status && err.response.data.status === 'Invalid Login') {
                    setAccessLocked(false)
                    setInvalidLogin(true)
                  } else {
                    setAccessLocked(false)
                    setInvalidLogin(false)
                    setErrorInformation(err.response.data.status)
                  }
                }
              } else {
                setAccessLocked(false)
                setInvalidLogin(false)
                setErrorInformation(
                  intl.formatMessage({
                    id: 'AUTH.VALIDATION.SERVER_OUTAGE'
                  })
                )
              }
            } else {
              setAccessLocked(false)
              setInvalidLogin(false)
              setErrorInformation(
                intl.formatMessage({
                  id: 'AUTH.VALIDATION.SERVER_OUTAGE'
                })
              )
            }
            // setStatus('The login details are incorrect')
          })
      }, 1000)
    }
  })

  return (
    <form className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework' noValidate id='kt_login_password_reset_form' onSubmit={formik.handleSubmit}>
      <div className='text-center mb-10'>
        {/* begin::Title */}
        <h1 className='text-dark fw-bolder mb-15'>Secure Access, Password-Free</h1>
        {/* end::Title */}

        {/* begin::Link */}
        <div className='text-dark fw-bolder fs-6 mb-10 '>Signing in with a code is fast, safe and easy.</div>
        {/* end::Link */}
        <div className='text-gray-500 fw-semibold fs-6'>Enter your username and birthdate and we&apos;ll email you a one-time code to access your account.</div>
      </div>

      {hasErrors === true && accessLocked === true && invalidLogin !== true && (
        <div className='mb-lg-15 alert alert-danger'>
          <a href='https://www.afspa.org/secure-form-member-portal-support/' target='_blank' rel='noreferrer'>
            <div className='alert-text font-weight-bold'>Your account is locked. Please click here to contact AFSPA for assistance.</div>
          </a>
        </div>
      )}

      {hasErrors === true && accessLocked === false && invalidLogin === true && (
        <div className='mb-lg-15 alert alert-danger'>
          <a href='https://www.afspa.org/secure-form-member-portal-support/' target='_blank' rel='noreferrer'>
            <div className='alert-text font-weight-bold'>
              The username and date of birth you entered could not be verified. <br /> <br />
              Both pieces of information must match our records. <br />
              This is a requirement to successfully log in to the Member Portal <br /> <br /> <strong>Please try again OR click here to contact us for assistance.</strong>
            </div>
          </a>
        </div>
      )}

      {hasErrors === true && accessLocked !== true && invalidLogin !== true && (
        <div className='mb-lg-15 alert alert-danger'>
          <div className='alert-text font-weight-bold'>{errorInformation}</div>
        </div>
      )}

      {hasErrors === false && (
        <div className='mb-10 bg-light-primary p-8 rounded'>
          <div className='text-primary'>Your information has been verified. Please check your email and click the link to login</div>
        </div>
      )}
      {/* end::Title */}

      {/* begin::Form group */}
      <div className='fv-row mb-3'>
        <input
          type='text'
          placeholder='Username'
          autoComplete='off'
          {...formik.getFieldProps('username')}
          className={clsx(
            'form-control bg-transparent',
            {'is-invalid': formik.touched.username && formik.errors.username},
            {
              'is-valid': formik.touched.username && !formik.errors.username
            }
          )}
        />
        {formik.touched.username && formik.errors.username && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.username}</span>
            </div>
          </div>
        )}
      </div>
      <div className='d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8'>
        <div />
        <Link to='/auth/forgot-password/forgot' className='link-primary'>
          Forgot Username ?
        </Link>
      </div>

      <div className='fv-row mb-20'>
        <input
          type='text'
          placeholder='Date of Birth (MM/DD/YYYY)'
          autoComplete='off'
          {...formik.getFieldProps('dateofbirth')}
          className={clsx(
            'form-control bg-transparent',
            {'is-invalid': formik.touched.dateofbirth && formik.errors.dateofbirth},
            {
              'is-valid': formik.touched.dateofbirth && !formik.errors.dateofbirth
            }
          )}
        />
        {formik.touched.dateofbirth && formik.errors.dateofbirth && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.dateofbirth}</span>
            </div>
          </div>
        )}
      </div>

      {/* end::Form group */}

      {/* begin::Form group */}
      <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
        <button type='submit' id='kt_password_reset_submit' className='btn btn-primary me-4'>
          <span className='indicator-label'>Continue</span>
          {loading && (
            <span className='indicator-progress'>
              Please wait...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
        <Link to='/auth/login'>
          <button type='button' id='kt_login_password_reset_form_cancel_button' className='btn btn-light' disabled={formik.isSubmitting || !formik.isValid}>
            Cancel
          </button>
        </Link>{' '}
      </div>
      {/* end::Form group */}
    </form>
  )
}
